<div id="hunt-details-page-wrapper">
  <div class="page-header">
    <div class="left">
      <hyperkit-breadcrumb-list class="breadcrumb-list" [items]="breadcrumbs()"></hyperkit-breadcrumb-list> 
      <hyperkit-typography variant="h2">{{ huntContext.state.name() }}</hyperkit-typography>
      <div class="meta-data-tags">
        <hyperkit-badge
        [variant]="huntContext.editor.priorityVariant()"
        [size]="'base'"
        [indicator]="'none'"
        [text]="huntContext.editor.priority()">
      </hyperkit-badge>
      <hyperkit-badge
      [variant]="huntContext.editor.statusVariant()"
      [size]="'base'"
      [indicator]="'none'"
      textLeft="Status"
      [text]="huntContext.editor.status()">
    </hyperkit-badge>
    <hyperkit-badge
    *ngIf="huntContext.editor.outcome()"
    [variant]="huntContext.editor.outcomeVariant()"
    [size]="'base'"
    [indicator]="'none'"
    textLeft="Outcome"
    [text]="huntContext.editor.outcome()">
  </hyperkit-badge>
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Created'"
        [text]="huntContext.state.created()">
      </hyperkit-tag>
      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Last Modified'"
      [text]="huntContext.state.lastModified()">
    </hyperkit-tag>
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Author'"
        [text]=" huntContext.state.assigneeFullName()">
      </hyperkit-tag>
      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Author'"
      [text]=" huntContext.state.authorFullName()">
    </hyperkit-tag>    
    <hyperkit-tag
    *ngIf="huntContext.query.hasHuntTemplate()"
    routerLink="/hunt/hunt-template/{{ huntContext.state.huntTemplateId()}}"
    icon="link-2"
    [mode]="'fill'"
    [closable]="false"
    [textLeft]="'Template'"
    [text]=" huntContext.state.huntTemplateName()">
  </hyperkit-tag>  
      </div>
    </div>
    <div class="right">
      <hyperkit-error *ngIf="error" [error]="error"></hyperkit-error>
      <hyperkit-button variant="standard" color="secondary" size="small" text="Back to Hunt"  (click)="backToHunt()" icon="arrow-left" iconPosition="left"></hyperkit-button>
      <hyperkit-button variant="standard" color="primary" size="small" (click)="done()" text="Done"></hyperkit-button>
    </div>
  </div>
  <div class="page-content">
      <div id="report">
        <div id="report-header">
          <div id="report-title">
            <hyperkit-typography variant="h5">Threat Hunt Report</hyperkit-typography>
          </div>
          <div id="report-list">
            <div class="report-container">
              <div *ngFor="let section of sections()">
                <hyperkit-report-section 
                  [section]="section" 
                  [selectedSectionId]="selectedSectionId"
                  (selectSection)="onSelectSection($event)">
                </hyperkit-report-section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="report-details">
        <router-outlet></router-outlet>
      </div>
      <div id="hunt-notes">
        <hunt-details-editor title="Notes"
        [value]="huntContext.editor.notes()"
        (valueChange)="huntContext.editor.updateNotes($event)">
      </hunt-details-editor>
      </div>
  </div>
</div>
